import React, { CSSProperties, useEffect, useState } from 'react';
import classnames from 'classnames/bind';

import styles from './index.module.scss';
const cx = classnames.bind(styles);

/* eslint-disable-next-line */
export interface FormTextareaProps {
  rows?: number;
  placeholder?: string;
  value: string;
  errorMessage: string;
  maxLength?: number;
  onTextChange: (string: string) => void;
  onFocus?(): void;
  fixResizeVertical?: boolean;
  style?: CSSProperties;
}

const FormTextArea = ({
  rows = 4,
  placeholder = '',
  value = '',
  errorMessage = '',
  maxLength = 999,
  onTextChange,
  onFocus,
  fixResizeVertical = true,
  style,
}: FormTextareaProps) => {
  const [state, setState] = useState({
    text: '',
  });
  const { text } = state;

  useEffect(() => {
    if (text !== value) {
      setState({ text: value });
    }
  }, [text, value]);

  const onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value;
    onTextChange(value);
    setState({ text: value });
  };

  const Error = () => {
    return errorMessage ? (
      <div className={styles['error-message']}>{errorMessage}</div>
    ) : (
      <></>
    );
  };

  const textareaClass = cx({
    textarea: true,
    error: errorMessage,
  });

  return (
    <>
      <div className={textareaClass}>
        <textarea
          style={{
            width: '100%',
            resize: fixResizeVertical ? 'vertical' : 'both',
            ...style,
          }}
          placeholder={placeholder}
          value={text}
          maxLength={maxLength}
          onChange={onChange}
          onFocus={onFocus}
          rows={rows}
        />
      </div>
      <Error />
    </>
  );
};
export default FormTextArea;
